/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ReferenceMaterialPassageDto } from '../../models/reference-material-passage-dto';
import { SearchReferenceMaterialDto } from '../../models/search-reference-material-dto';

export interface ReferenceMaterialControllerSearch$Params {
      body: SearchReferenceMaterialDto
}

export function referenceMaterialControllerSearch(http: HttpClient, rootUrl: string, params: ReferenceMaterialControllerSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ReferenceMaterialPassageDto>>> {
  const rb = new RequestBuilder(rootUrl, referenceMaterialControllerSearch.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ReferenceMaterialPassageDto>>;
    })
  );
}

referenceMaterialControllerSearch.PATH = '/reference-material/search';
